// extracted by mini-css-extract-plugin
export default {"root":"bJ3C0jxM7h4rn4lnp5T6"};